import { API } from "config/API"

export const getTicketInvoices = async (filters) => {
  const response = await API.get("/ticket-invoices", { params: filters })
  return response
}

export const getBillingSummary = async (filters) => {
  const response = await API.get("/ticket-invoices/billing_summary", { params: filters })
  return response
}

export const getTicketInvoice = async (id) => {
  const response = await API.get(`/ticket-invoices/${id}`)
  return response
}

export const getTicketInvoiceEmailHistory = async (id) => {
  const response = await API.get(`/ticket-invoices/${id}/email-history`)
  return response
}

export const createTicketInvoice = async (data) => {
  const response = await API.post("/ticket-invoices", data)
  return response
}

// Timbrar factura en SAT (obtener UUID real)
export const timbrarTicketInvoice = async (id) => {
  const response = await API.post(`/ticket-invoices/${id}/timbrado`)
  return response
}

export const cancelTicketInvoice = async (id, reason) => {
  const response = await API.post(`/ticket-invoices/${id}/cancel`, { reason })
  return response
}

export const downloadInvoiceXML = async (id) => {
  const response = await API.get(`/ticket-invoices/${id}/download-xml`, {
    responseType: "blob"
  })
  return response
}

export const downloadInvoicePDF = async (id) => {
  const response = await API.get(`/ticket-invoices/${id}/download-pdf`, {
    responseType: "blob"
  })
  return response
}

// Obtener acuse de recibo
export const getInvoiceAcuse = async (id) => {
  const response = await API.get(`/ticket-invoices/${id}/acuse`, {
    responseType: "blob"
  })
  return response
}

// Listar solo facturas timbradas (UUID real)
export const getStampedInvoices = async (filters) => {
  const response = await API.get("/ticket-invoices/invoices", { params: filters })
  return response
}
